/**
 * AuthCard — Branded card wrapper for auth screen forms.
 *
 * White surface, 28px border-radius (--radius-xl), brand shadow,
 * 1.5px border matching the design system.
 *
 * @param children — Form content.
 * @param width   — Max-width in px (default 440).
 */

import type { ReactNode } from 'react';

interface AuthCardProps {
  children: ReactNode;
  /** Max width of the card in pixels */
  width?: number;
}

export function AuthCard({ children, width = 440 }: AuthCardProps) {
  return (
    <div
      className="w-full bg-white border-[1.5px] border-[var(--border)] rounded-[28px] shadow-lg"
      style={{
        maxWidth: width,
        padding: '36px 36px 32px',
        boxShadow: 'var(--shadow-lg)',
      }}
    >
      {children}
    </div>
  );
}

export default AuthCard;